import PageName from 'constants/PageName';
import React, { FC } from 'react';
import styles from './Header.module.scss';

export interface HeaderProps {
  renderButton: () => void;
}

const Header: FC<HeaderProps> = ({ renderButton }) => {
  return (
    <div className={styles.header}>
      <div className={styles.titleContainer}>
        <h2 className={styles.title}>{PageName.DocuSignIntegration}</h2>
      </div>
      {renderButton()}
    </div>
  );
};

export default Header;
